import { render, staticRenderFns } from "./TestDoRight.vue?vue&type=template&id=0755f644&"
import script from "./TestDoRight.vue?vue&type=script&lang=js&"
export * from "./TestDoRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports